window.pd.adBlock = false;